let sentryInitialized = false;

export async function initSentry() {
  if (sentryInitialized) return;
  sentryInitialized = true;

  const Sentry = await import('@sentry/react');
  Sentry.init({
    dsn: 'https://20b75449bebf04b1c1c35702cef0fcbb@o4511141357092864.ingest.de.sentry.io/4511141365547088',
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    // Filter out benign, non-actionable DOM errors that React recovers from.
    // Browser auto-translate (Google Translate / Chrome translate widget) and
    // text extensions (Grammarly, password managers) mutate React-managed text
    // nodes; React's reconciler then throws NotFoundError on insertBefore /
    // removeChild during commit. App state stays consistent, so these are noise
    // rather than real defects. ResizeObserver loop warnings are likewise benign.
    ignoreErrors: [
      /Failed to execute 'insertBefore' on 'Node'/,
      /Failed to execute 'removeChild' on 'Node'/,
      /The node before which the new node is to be inserted/,
      /The node to be removed is not a child of this node/,
      /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/,
    ],
  });
}
